import React, { useState } from "react";

import { useAppDispatch } from "../../../../../src/app/hooks";

import StageWorkflowDecisionModal from "../../../../../src/features/stageWorkflow/components/StageWorkflowDecisionModal";
import { AcceptButton } from "../../../../../src/components/ui/button/v2/AcceptButton";
import { AddStageRequest, CaseStageAction, CaseStageEnum } from "../../../../api/caseStages";
import { updateCaseStage } from "../../logic/thunks";
import { useParams } from "react-router-dom";
import { showErrorToast, showSuccessToast } from "../../../../../src/lib/toast";

export const AcceptFwdCase: React.FC<{ next_stage: CaseStageEnum }> = ({ next_stage }) => {
  const dispatch = useAppDispatch();
  const { id: caseId } = useParams<{ id: string }>();

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleOpen = (): void => {
    setIsModalOpen(true);
  };

  const handleClose = (): void => {
    if (isLoading) return; 
    setIsModalOpen(false);
  };


  const handleAcceptFwdCase = async (): Promise<void> => {
  if (!caseId) return;

  try {
    setIsLoading(true);

    const request: AddStageRequest = {
      stage: next_stage,
      source_action: CaseStageAction.ACCEPT_FWD_CASE,
    };

    await dispatch(
      updateCaseStage({
        caseId,
        request,
      })
    ).unwrap();

    showSuccessToast("Case accepted successfully");
    setIsModalOpen(false);
  } catch (error) {
    showErrorToast("Failed to accept case");
  } finally {
    setIsLoading(false);
  }
};

  return (
    <>
      <AcceptButton
        label="Accept"
        onClick={handleOpen}
      />

      <StageWorkflowDecisionModal
        isOpen={isModalOpen}
        variant="accept"
        title="Accept Forwarded Case"
        subtitle="Are you sure you want to accept this case?"
        primaryButtonLabel="Accept"
        onPrimaryAction={handleAcceptFwdCase}
        onClose={handleClose}
        primaryDisabled={isLoading}
        primaryLoading={isLoading}
      />
    </>
  );
};